/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {EnableSidebar} from '../../../_metronic/layout/core'
import {KTIcon} from '../../../_metronic/helpers'
import {useAuth} from '../auth'
import TableRequest from '../../components/support/TableRequests'
import {useNavigate} from 'react-router-dom'
const SolicitudVacaciones: FC = () => {
  const {currentUser} = useAuth()
  const navigate = useNavigate()
  return (
    <EnableSidebar>
      <h2>Solicitudes de Vacaciones</h2>
      <TableRequest currentUser={currentUser} type='SOLVACACI' />
      <div className='d-flex flex-stack pt-15'>
        <button
          onClick={() => {
            navigate('/solicitud_vacaciones/new', {replace: true})
          }}
          className='btn  btn-primary me-3'
          style={{backgroundColor: '#182C59'}}
        >
          <span className='indicator-label'>
            <KTIcon iconName='plus' />
            Nueva Solicitud
          </span>
        </button>
      </div>
    </EnableSidebar>
  )
}

export {SolicitudVacaciones}
